import { createContext } from 'react';
import type { FormOrientation } from 'state/product-description/types';

export const FormOrientationContext = createContext<FormOrientation>('horizontal');
